/**
 * ca_preview: a sized, compressed copy of one of our own hosted photos.
 *
 * Operator photos under app.trip-planner.com.au/media are 1200-1920px
 * originals (~600KB). Cards render them `unoptimized`, so a results list or
 * region grid queued megabytes and the wells sat empty for seconds. The
 * jola-media imgix source fronts that folder, so ask it for the size the
 * card actually draws. Anything else is returned untouched.
 */
const MEDIA_ORIGIN = 'https://app.trip-planner.com.au/media/';

export function mediaThumb(src: string, width: number, height?: number): string {
  if (!src || !src.startsWith(MEDIA_ORIGIN)) return src;
  const base = process.env.NEXT_PUBLIC_MEDIA_IMGIX_URL || 'https://jola-media.imgix.net';
  const params = new URLSearchParams({ auto: 'format,compress', fit: 'crop', w: String(Math.round(width)), q: '72' });
  if (height) params.set('h', String(Math.round(height)));
  return `${base}${src.slice('https://app.trip-planner.com.au'.length)}?${params.toString()}`;
}
